import { useState, useEffect } from 'react'
import { get } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import { Icon } from '@iconify/react'
import FormLoader from '../../../../components/loader/FormLoader'
import { useNavigate } from 'react-router-dom'
import Pagination from '../../../../components/pagination/Pagination'
import FullLoader from '../../../../components/loader/FullLoader'
import CreateUser from './CreateUser'
import './Customers.scss'

function Customers() {
  const baseURL = (import.meta as any).env.VITE_BASE_URL
  const { notify, profile } = useGlobalContext()
  const navigate = useNavigate()
  const [customersList, setCustomersList] = useState<any>({ data: [] })
  const [bookingsLoading, setBookingsLoading] = useState(true)
  const [search, setSearch] = useState('')

  // Toggle between Customers and Analytics
  const [activeView, setActiveView] = useState<'customers' | 'analytics'>(
    'customers',
  )

  // Analytics state
  const [analyticsData, setAnalyticsData] = useState<any>({ topCustomers: [] })
  const [analyticsLoading, setAnalyticsLoading] = useState(false)
  const [analyticsParams, setAnalyticsParams] = useState({
    limit: 20,
    from: '',
    to: '',
  })

  function fetchCustomers(page: number, pageSize: number) {
    setBookingsLoading(true)
    let url = ''
    if (search) {
      url = `admin/users?search=${search}&page=${page}&limit=${pageSize}`
    } else {
      url = `admin/users?page=${page}&limit=${pageSize}`
    }
    get(url)
      .then((result: any) => {
        if (result.status === 200) {
          setCustomersList(result.data)
        } else {
          notify('error', result.message)
        }
        setBookingsLoading(false)
      })
      .catch(() => {
        setBookingsLoading(false)
      })
  }

  useEffect(() => {
    fetchCustomers(1, 10)
  }, [])

  // Fetch Analytics Data
  function fetchAnalytics() {
    if (!analyticsParams.from || !analyticsParams.to) {
      notify('error', 'Please select both from and to dates')
      return
    }
    setAnalyticsLoading(true)
    const url = `admin/top-customers?limit=${analyticsParams.limit}&from=${analyticsParams.from}&to=${analyticsParams.to}`
    get(url)
      .then((result: any) => {
        if (result.status === 200) {
          setAnalyticsData(result.data)
        } else {
          notify('error', result.message)
        }
        setAnalyticsLoading(false)
      })
      .catch(() => {
        setAnalyticsLoading(false)
      })
  }

  //<----------- Download Excel and CSV --------------->
  const [downloading, setDownloading] = useState(false)

  const handleDownload = async (format: string) => {
    const token = sessionStorage.getItem('token')
    let apiUrl = `${baseURL}/admin/users/export?format=${format}`

    try {
      // Make an API request to fetch the Excel file
      setDownloading(true)
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          // Add any necessary headers, like authorization if required
          Authorization: `Bearer ${token}`,
        },
      })

      if (!response.ok) {
        setDownloading(false)
        throw new Error('Failed to download file')
      }

      // Convert the response to a Blob
      const blob = await response.blob()

      // Extract the filename from the "Content-Disposition" header
      const fileName = `Customers`

      // Create a download link for the Blob
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = fileName // Use the filename from the backend
      document.body.appendChild(a) // Append to the DOM
      a.click() // Trigger the download
      a.remove() // Clean up
      window.URL.revokeObjectURL(url) // Release memory
      setDownloading(false)
    } catch (error) {
      console.error('Error downloading the file:', error)
    }
  }

  // Analytics Export
  const handleAnalyticsExport = async () => {
    if (!analyticsParams.from || !analyticsParams.to) {
      notify('error', 'Please select both from and to dates')
      return
    }
    const token = sessionStorage.getItem('token')
    let apiUrl = `${baseURL}/admin/top-customers/export?limit=${analyticsParams.limit}&from=${analyticsParams.from}&to=${analyticsParams.to}`

    try {
      setDownloading(true)
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      if (!response.ok) {
        setDownloading(false)
        throw new Error('Failed to download file')
      }

      const blob = await response.blob()
      const fileName = `Top_Customers_Analytics`

      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = fileName
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)
      setDownloading(false)
    } catch (error) {
      console.error('Error downloading the file:', error)
      setDownloading(false)
    }
  }
  const selectCustomer = (id: string) => {
    navigate(`/admin/customer/${id}`)
  }

  //
  const [showCreateUser, setSetShowCreateUser] = useState(false)

  return (
    <div className='home customers-page'>
      {downloading && <FullLoader />}
      {showCreateUser && (
        <CreateUser
          fetchCustomers={fetchCustomers}
          close={() => setSetShowCreateUser(false)}
        />
      )}
      <div className='home_tag flex justify-between items-center'>
        <div className='page-header-left flex items-center'>
          {profile?.role !== 'agent' && (
            <div className='view-toggle flex'>
              <button
                className={`toggle-btn ${activeView === 'customers' ? 'active' : ''}`}
                onClick={() => setActiveView('customers')}
              >
                Customers
              </button>
              <button
                className={`toggle-btn ${activeView === 'analytics' ? 'active' : ''}`}
                onClick={() => setActiveView('analytics')}
              >
                Analytics
              </button>
            </div>
          )}
        </div>
        {activeView === 'customers' && (
          <button
            className='create-btn'
            onClick={() => setSetShowCreateUser(true)}
          >
            + Create User
          </button>
        )}
      </div>
      <div className='home_tables'>
        <div className='left'>
          {activeView === 'customers' ? (
            <>
              {bookingsLoading ? (
                <FormLoader position='center' />
              ) : (
                <>
                  <div className='flex justify-between items-center search-btns flex-wrap'>
                    <div className='search flex flex-wrap'>
                      <input
                        type='search'
                        name=''
                        id=''
                        value={search}
                        placeholder='search by name or tracking Id or user Id'
                        onChange={(e) => {
                          setSearch(e.target.value)
                        }}
                      />{' '}
                      <button
                        onClick={() => {
                          fetchCustomers(1, 10)
                        }}
                      >
                        Search
                      </button>
                    </div>
                    <div className='buttons flex dif'>
                      <button onClick={() => handleDownload('csv')}>
                        Export CSV
                      </button>
                      <button onClick={() => handleDownload('excel')}>
                        Export EXCEL
                      </button>
                    </div>
                  </div>
                  {customersList.users.length > 0 ? (
                    <>
                      <div className='mobile-table'>
                        {customersList.users.map((data: any, i: number) => (
                          <div
                            className='card'
                            onClick={() =>
                              navigate(`/admin/customer/${data._id}`)
                            }
                            key={data._id}
                          >
                            <div className='flex justify-between row'>
                              <div className='count flex items-center justify-center'>
                                {i + 1}
                              </div>
                            </div>
                            <div className='row flex justify-between'>
                              <h4>Full Name</h4>
                              <p>
                                {data.firstname} {data.lastname}
                              </p>
                            </div>
                            <div className='row flex justify-between'>
                              <h4>Role</h4>
                              <p>{data.role}</p>
                            </div>
                            <div className='row flex justify-between'>
                              <h4>Email</h4>
                              <p>{data.email}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                      <table className='desktop-table'>
                        <thead>
                          <tr>
                            <th>S/N</th>
                            <th>Full Name</th>
                            <th>Username</th>
                            <th>Type</th>
                            <th>Email</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {customersList.users.map((data: any, i: number) => (
                            <tr key={data._id}>
                              <td>{i + 1}</td>
                              <td onClick={() => selectCustomer(data._id)}>
                                {data.firstname} {data.lastname}
                              </td>
                              <td
                                onClick={() => selectCustomer(data._id)}
                                className='count'
                              >
                                {data.username}
                              </td>
                              <td className='count'>{data.role}</td>
                              <td className='count'>{data.email}</td>
                              <td className='icons dif'>
                                <span
                                  className='PU'
                                  onClick={() => selectCustomer(data._id)}
                                >
                                  view
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <Pagination
                        className='pagination-bar'
                        currentPage={customersList.pagination.page}
                        totalCount={customersList.pagination.totalPages}
                        pageSize={customersList.pagination.limit}
                        onPageChange={(page: number, pageSize: number) => {
                          fetchCustomers(page, pageSize)
                        }}
                      />
                    </>
                  ) : (
                    <div className='empty flex justify-center'>
                      <div className='empty-cover'>
                        <Icon icon='majesticons:book-line' />
                        <h1>No Bookings To Show</h1>
                      </div>
                    </div>
                  )}
                </>
              )}
            </>
          ) : (
            <>
              {analyticsLoading ? (
                <FormLoader position='center' />
              ) : (
                <>
                  <div className='analytics-filters'>
                    <div className='filter-row'>
                      <div className='filter-field'>
                        <label>Limit</label>
                        <input
                          type='number'
                          placeholder='20'
                          value={analyticsParams.limit}
                          onChange={(e) =>
                            setAnalyticsParams({
                              ...analyticsParams,
                              limit: Number(e.target.value),
                            })
                          }
                          style={{ maxWidth: '110px' }}
                        />
                      </div>
                      <div className='filter-field'>
                        <label>From Date</label>
                        <input
                          type='date'
                          value={analyticsParams.from}
                          onChange={(e) =>
                            setAnalyticsParams({
                              ...analyticsParams,
                              from: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className='filter-field'>
                        <label>To Date</label>
                        <input
                          type='date'
                          value={analyticsParams.to}
                          onChange={(e) =>
                            setAnalyticsParams({
                              ...analyticsParams,
                              to: e.target.value,
                            })
                          }
                        />
                      </div>
                      <button className='fetch-btn' onClick={fetchAnalytics}>
                        Fetch Analytics
                      </button>
                      <button
                        className='export-btn'
                        onClick={handleAnalyticsExport}
                      >
                        Export Analytics
                      </button>
                    </div>
                  </div>

                  {analyticsData.topCustomers &&
                  analyticsData.topCustomers.length > 0 ? (
                    <>
                      <div className='mobile-table'>
                        {analyticsData.topCustomers.map(
                          (data: any, i: number) => (
                            <div className='card' key={data.userId}>
                              <div className='flex justify-between row'>
                                <div className='count flex items-center justify-center'>
                                  {i + 1}
                                </div>
                              </div>
                              <div className='row flex justify-between'>
                                <h4>Full Name</h4>
                                <p>
                                  {data.firstname} {data.lastname}
                                </p>
                              </div>
                              <div className='row flex justify-between'>
                                <h4>Email</h4>
                                <p>{data.email}</p>
                              </div>
                              <div className='row flex justify-between'>
                                <h4>Phone</h4>
                                <p>{data.phonenumber}</p>
                              </div>
                              <div className='row flex justify-between'>
                                <h4>Bookings</h4>
                                <p>{data.bookingCount}</p>
                              </div>
                              <div className='row flex justify-between'>
                                <h4>Total Charge</h4>
                                <p>
                                  ₦
                                  {data.totalCharge.toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </p>
                              </div>
                            </div>
                          ),
                        )}
                      </div>
                      <table className='desktop-table'>
                        <thead>
                          <tr>
                            <th>Rank</th>
                            <th>Full Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Booking Count</th>
                            <th>Total Charge (₦)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {analyticsData.topCustomers.map(
                            (data: any, i: number) => (
                              <tr key={data.userId}>
                                <td>
                                  <span
                                    className={`rank-badge rank-${i < 3 ? i + 1 : 'other'}`}
                                  >
                                    {i + 1}
                                  </span>
                                </td>
                                <td>
                                  {data.firstname} {data.lastname}
                                </td>
                                <td className='count'>{data.email}</td>
                                <td className='count'>{data.phonenumber}</td>
                                <td className='count'>{data.bookingCount}</td>
                                <td className='count'>
                                  ₦
                                  {data.totalCharge.toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </td>
                              </tr>
                            ),
                          )}
                        </tbody>
                      </table>
                    </>
                  ) : (
                    <div className='empty flex justify-center'>
                      <div className='empty-cover'>
                        <Icon icon='majesticons:chart-line' />
                        <h1>No Analytics Data To Show</h1>
                        <p>
                          Select date range and fetch analytics to view top
                          customers
                        </p>
                      </div>
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default Customers
